import { getContactsImports } from 'Services/invoices';
import { useQuery } from '@tanstack/react-query';
import { trackError } from 'Utils/errorMonitoring';

export default function useContactsImports() {
    const { data, isLoading } = useQuery({
        queryKey: ['contacts-imports'],
        queryFn: getContactsImports,
        onError: (error) => trackError(error),
    });

    return {
        imports: data?.items ?? [],
        isLoading,
    };
}
